const cbr150rData = {
  slug: "cbr150r",
  name: "Honda CBR150R",

  hero: {
    shortDescription:
      "Motor sport full fairing 150cc dengan desain balap dan teknologi modern untuk performa maksimal",

    variants: [
      {
        key: "std-black",
        label: "STD",
        fullName: "Honda CBR 150R STD Victory Matte Black",
        startPrice: 39214000,
      },
      {
        key: "std-red",
        label: "STD",
        fullName: "Honda CBR 150R STD Racing Red",
        startPrice: 39924000,
      },
      {
        key: "std-tricolor",
        label: "STD",
        fullName: "Honda CBR 150R STD Tricolor",
        startPrice: 39924000,
      },
      {
        key: "abs-black",
        label: "ABS",
        fullName: "Honda CBR 150R ABS Victory Matte Black",
        startPrice: 43479000,
      },
      {
        key: "abs-tricolor",
        label: "ABS",
        fullName: "Honda CBR 150R ABS Tricolor",
        startPrice: 44189000,
      },
    ],

    slides: [
      {
        variantKey: "std-black",
        image: "/assets/motor/produk/cbr150r/Honda-CBR-150R-STD-Victory-Matte-Black.webp",
        specs: {
          engine: "149,16 cc, 4 Langkah, DOHC, 4 Katup, Pendingin Cairan",
          power: "12,4 kW (16,9 PS) / 9.000 rpm",
          smartKey: true,
        },
      },
      {
        variantKey: "std-red",
        image: "/assets/motor/produk/cbr150r/Honda-CBR150R-Racing-Red-1.webp",
        specs: {
          engine: "149,16 cc, 4 Langkah, DOHC, 4 Katup, Pendingin Cairan",
          power: "12,4 kW (16,9 PS) / 9.000 rpm",
          smartKey: true,
        },
      },
      {
        variantKey: "std-tricolor",
        image: "/assets/motor/produk/Honda-CBR-150R-STD-Tricolor.webp",
        specs: {
          engine: "149,16 cc, 4 Langkah, DOHC, 4 Katup, Pendingin Cairan",
          power: "12,4 kW (16,9 PS) / 9.000 rpm",
          smartKey: true,
        },
      },
      {
        variantKey: "abs-black",
        image: "/assets/motor/produk/cbr150r/Honda-CBR-150R-ABS-Victory-Matte-Black.webp",
        specs: {
          engine: "149,16 cc, 4 Langkah, DOHC, 4 Katup, Pendingin Cairan",
          power: "12,4 kW (16,9 PS) / 9.000 rpm",
          smartKey: true,
        },
      },
      {
        variantKey: "abs-tricolor",
        image: "/assets/motor/produk/cbr150r/Honda-CBR-150R-ABS-Tricolor.webp",
        specs: {
          engine: "149,16 cc, 4 Langkah, DOHC, 4 Katup, Pendingin Cairan",
          power: "12,4 kW (16,9 PS) / 9.000 rpm",
          smartKey: true,
        },
      },
    ],
  },

  description: {
    sections: [
      {
        type: "paragraph",
        text:
          "Honda CBR150R merupakan motor sport full fairing yang mengusung DNA balap Honda dengan desain aerodinamis dan performa tinggi.",
      },
      {
        type: "paragraph",
        text:
          "Ditenagai mesin 150cc DOHC 4 katup berpendingin cairan, CBR150R menawarkan akselerasi responsif serta kestabilan optimal untuk berkendara harian maupun di lintasan.",
      },
      {
        type: "heading",
        text: "Desain Racing Full Fairing",
      },
      {
        type: "paragraph",
        text:
          "Tampilan agresif dengan fairing tajam, lampu depan full LED, serta posisi berkendara sporty memberikan sensasi motor balap sejati.",
      },
      {
        type: "heading",
        text: "Teknologi Modern dan Keamanan",
      },
      {
        type: "paragraph",
        text:
          "Dilengkapi fitur Assist & Slipper Clutch, Honda Smart Key System, serta ABS dual channel pada tipe tertentu untuk meningkatkan kenyamanan dan keamanan.",
      },
    ],
  },

  specificationsDetail: {
    mesin: [
      [
        "Tipe Mesin",
        "4 Langkah, DOHC, 4 Katup, Pendingin Cairan",
      ],
      ["Sistem Suplai Bahan Bakar", "PGM-FI"],
      ["Kapasitas Mesin", "149,16 cc"],
      ["Daya Maksimum", "12,4 kW (16,9 PS) / 9.000 rpm"],
      ["Torsi Maksimum", "14,4 Nm / 7.000 rpm"],
      ["Transmisi", "Manual, 6 Percepatan"],
    ],

    rangka: [
      ["Tipe Rangka", "Diamond Steel Frame"],
      ["Suspensi Depan", "Upside Down (USD)"],
      ["Suspensi Belakang", "Monoshock"],
      ["Rem Depan", "Cakram dengan ABS (tipe ABS)"],
      ["Rem Belakang", "Cakram dengan ABS (tipe ABS)"],
    ],

    dimensi: [
      ["Panjang x Lebar x Tinggi", "1.983 x 700 x 1.090 mm"],
      ["Tinggi Jok", "782 mm"],
      ["Jarak Sumbu Roda", "1.310 mm"],
      ["Berat", "137–139 kg"],
    ],

    kapasitas: [
      ["Kapasitas Tangki Bahan Bakar", "12 Liter"],
    ],

    kelistrikan: [
      ["Sistem Pengapian", "Full Transistorized"],
      ["Tipe Aki", "12V MF"],
      ["Sistem Starter", "Electric Starter"],
    ],
  },

  fullFeatures: {
    title: "Fitur Unggulan Honda CBR150R",
    items: [
      {
        title: "Mesin 150cc DOHC",
        desc:
          "Mesin performa tinggi dengan akselerasi responsif dan karakter balap.",
      },
      {
        title: "Assist & Slipper Clutch",
        desc:
          "Membuat perpindahan gigi lebih ringan dan mencegah roda belakang selip saat deselerasi.",
      },
      {
        title: "Dual Channel ABS",
        desc:
          "Sistem pengereman ABS depan dan belakang untuk keamanan maksimal. *Tersedia pada tipe ABS.",
      },
      {
        title: "Upside Down Front Suspension",
        desc:
          "Suspensi depan USD yang meningkatkan stabilitas dan handling saat kecepatan tinggi.",
      },
      {
        title: "Honda Smart Key System",
        desc:
          "Sistem keyless dengan alarm dan answer back system untuk keamanan modern.",
      },
      {
        title: "Full LED Lighting System",
        desc:
          "Pencahayaan full LED dengan visibilitas optimal dan tampilan sporty.",
      },
      {
        title: "Panel Meter Full Digital",
        desc:
          "Panel meter digital informatif dengan gaya balap.",
      },
    ],
  },
};

export default cbr150rData;
